
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.667 2.75a.917.917 0 00-.917.917A15.583 15.583 0 0018.333 19.25a.917.917 0 00.917-.917v-3.208a.917.917 0 00-.917-.917c-1.145 0-2.245-.183-3.272-.522a.936.936 0 00-.935.22l-2.017 2.016a13.791 13.791 0 01-6.04-6.04l2.016-2.026a.88.88 0 00.23-.917 10.414 10.414 0 01-.523-3.272.917.917 0 00-.917-.917H3.667zm10.083 0v1.375h3.208l-5.041 5.042.916.916 5.042-5.041V8.25h1.375v-5.5h-5.5z","fill":"#FE6600"}})])
          )
        }
      }
    